import { deepcopy } from "../util.js";

export function translateRescaleSizeChannel(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let layer = source?.layer?.[mapping[args[0]].layer];
  if (layer?.mark?.size?.field !== undefined) {
    if (layer.mark.size.scale?.range !== undefined && config.has_old_new_size) {
      let size_factor = Math.sqrt((config.new_size[0] * config.new_size[1]) / (config.old_size[0] * config.old_size[1]));
      let old_scale = deepcopy(layer.mark.size.scale.range);
      let old_scale_max = Math.max(...old_scale), old_scale_min = Math.min(...old_scale);
      let new_scale_max = Math.min(old_scale_max * size_factor, 5000), new_scale_min = Math.max(old_scale_min * size_factor, 9);
      let new_scale = old_scale.map(d => {
        return new_scale_min + (d - old_scale_min) / (old_scale_max - old_scale_min) * (new_scale_max - new_scale_min);
      });
      let rule = {
        category: "recommender",
        description: `Rescale size channel for ${layer.mark.type}`,
        specifier: {
          role: "mark",
          mark: layer.mark.type,
          channel: "size"
        },
        action: "modify",
        option: {
          size: {
            scale: {
              range: new_scale
            }
          }
        }
      };
      if (layer.name) rule.id = layer.name;
      rules.push(rule);
    }
  } else {
    let size_factor = Math.sqrt((config.new_size[0] * config.new_size[1]) / (config.old_size[0] * config.old_size[1]));
    let old_size = layer.mark.size.value;
    let new_size = Math.min(Math.max(Math.round(old_size * size_factor), 25), 3000);
    let rule = {
      category: "recommender",
      description: `Rescale size value for ${layer.mark.type}`,
      specifier: {
        role: "mark",
        mark: layer.mark.type,
        channel: "size"
      },
      action: "modify",
      option: {
        size: {
          value:
            new_size
        }
      }
    };
    if (layer.name) rule.id = layer.name;
    rules.push(rule);
  }
  return rules;
}

export function translateRemoveChannel(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_channel,l0,url).
  let rules = [];

  let layer = source?.layer?.[mapping[args[0]].layer];
  if (layer) {
    let rule_mv = {
      category: "recommender",
      description: `Rescale ${args[1]} channel for ${layer.mark.type}`,
      specifier: { role: "mark", mark: layer.mark.type },
      action: "modify",
      option: {}
    };
    rule_mv.option[args[1]] = null;
    if (args[1] === "url" && layer.mark.type === "image") {
      rule_mv.option.type = "square";
      let old_size;
      if (layer.mark.width !== undefined && layer.mark.height !== undefined) {
        old_size = layer.mark.width * layer.mark.height;
        rule_mv.option.width = null;
        rule_mv.option.height = null;
      } else if (layer.mark.width !== undefined) {
        old_size = layer.mark.width * layer.mark.width;
        rule_mv.option.width = null;
      } else if (layer.mark.height !== undefined) {
        old_size = layer.mark.height * layer.mark.height;
        rule_mv.option.height = null;
      }
      let new_size;
      if (old_size && config.has_old_new_size) {
        new_size = old_size / (config.old_size[0] * config.old_size[0]) * (config.new_size[0] * config.new_size[0]);
      } else if (old_size && config.has_old_new_width) {
        new_size = old_size / (config.old_size[0] * config.old_size[0]) * (config.new_size[0] * config.new_size[0]);
      } else if (old_size) {
        new_size = old_size;
      }
      rule_mv.option.size = { value: new_size };
    }
    rules.push(rule_mv);
  }
  return rules;
}